import React from 'react'
import MaterialSymbol from '../material-symbol'

const VolumeUp = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="volume_up" {...props} />
))

VolumeUp.displayName = 'VolumeUp'

export default VolumeUp
